module.exports = __webpack_public_path__ + "assets/clear_map_primary.53a96cc3.svg";